import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { useCalibrationFiltersStore } from "@/stores/calibration";

// Serwis odpowiedzialny za pobieranie danych kalibracji z API
class CalibrationService {
  /**
   * Buduje query string na podstawie ustawionych filtrów w store
   * Iteruje po kluczach filtersStore.filters i tworzy ciąg klucz=wartość
   * Pomija puste lub zerowe wartości
   * @returns {string} ciag zapytania dołączenia do URL
   */
  getQueryString() {
    // Pobranie instancji store Pinia z filtrami
    const filtersStore = useCalibrationFiltersStore();
    // Lista kluczy z obiektu filters, jeśli istnieje
    const keys =
      filtersStore && filtersStore.filters
        ? Object.keys(filtersStore.filters)
        : [];

    // Jeśli mamy jakieś klucze, to mapujemy je na 'key=value', łączymy '&'
    // Pomijamy wartości puste lub zero
    return keys.length > 0
      ? keys
          .map((key) =>
            filtersStore.filters[key] && // wartość istnieje (nie null/undefined)
            (filtersStore.filters[key].length > 0 || // tablica niepusta
             filtersStore.filters[key] > 0) // lub liczba > 0
              ? key + "=" + filtersStore.filters[key]
              : ""
          )
          .filter((segment) => segment !== "") // usuwamy puste segmenty
          .join("&") // łączymy w query string
      : ""; // jeśli brak kluczy, zwracamy pusty string
  }

  /**
   * Wysyła GET na endpoint /diagnostic-calibrations z query parametrami
   * @returns {Promise} obietnica z odpowiedzią serwera
   */
  // getCalibrations() {
  //   // Tworzymy pełny URL z query stringiem
  //   // Wykonujemy żądanie GET za pomocą fetchWrapper
  //   let response = fetchWrapper.get(`${process.env.VUE_APP_API_URL}/diagnostic-calibrations?` +
  //   this.getQueryString());

  //   console.log(response);

  //   return response;
  // }

  /**
   * Wysyła GET na endpoint /diagnostic-calibrations z query parametrami
   * @returns {Promise} obietnica z odpowiedzią serwera
   */
  getCalibrations() {
    // podstawowy query string z Twoich parametrów
    const baseQs = this.getQueryString();
  
    // na sztywno dopisujemy parametry generowania wykresu
    const graphQs = [
      'addGraph=true',          // włącz generowanie wykresu
      'graphType=linePlot',     // typ wykresu
      'graphWidth=980',         // szerokość
      'graphHeight=458'         // wysokość
    ].join('&');
  
    // złożony URL
    const url = `${process.env.VUE_APP_API_URL}/diagnostic-calibrations?${baseQs}&${graphQs}`;
  
    return fetchWrapper
      .get(url)
      .then(response => {
        // console.log('Server response:', response); // już dana odpowiedź, nie Promise
        return response;
      })
      .catch(error => {
        console.error('Error fetching calibrations:', error);
        throw error;
      });
  }  

  addNewCalibrationTime(time) {
    // console.log('time: ' + time);
    // 1) zparsuj istniejący query string
    const params = new URLSearchParams(this.getQueryString())
    // const timeParam = moment(time).toISOString();
  
    let response = fetchWrapper.post(
      `${process.env.VUE_APP_API_URL}/diagnostic-calibrations-finish-date?locations=${params.get('locations')}&time=${new Date(time).toISOString()}`
    );

    // console.log(response);

    return response;
  }

  async getCalibrationsDeviation() {
    try {
      const src = new URLSearchParams(this.getQueryString());
  
      // locations bez nawiasów [ ]
      const locations = (src.get('locations') || '').replace(/^\[|\]$/g, '');
  
      const qs = new URLSearchParams({
        dateTimeStart: src.get('dateTimeStart') || '',
        dateTimeEnd:   src.get('dateTimeEnd')   || '',
        locations,
        graphType:   'linePlot',
        graphWidth:  '980',
        graphHeight: '458',
      });
  
      const url = `${process.env.VUE_APP_API_URL}/diagnostic-calibration-deviation?${qs.toString()}`;
      // console.log('GET', url);
  
      const response = await fetchWrapper.get(url);   // <— czekamy na odpowiedź
      // console.log('Server response:', response);      // tu już są dane, nie Promise
      return response;
    } catch (error) {
      console.error('Error fetching calibrations deviation:', error);
      throw error;
    }
  }
}

// Eksport pojedynczej instancji serwisu (singleton)
export default new CalibrationService();